export enum FeatureToggle {
  notificationSettings = 'rt_notification_center',
}
